import React, { useState } from 'react';
import '../Styles/Sidebar.css';
import DappMenu from './DappMenu';
import DappMain from './DappMain';

const Sidebar = ({ blockchainInfo, setUserMessage, setShowWidget }) => {
    const active = blockchainInfo.active;
    const dAppOptions = active ? (blockchainInfo.supportedDapps || []) : [];
    const placeholderText = active ? "Select dApp" : "Coming soon! 🚀";
    const [currentDapp, setCurrentDapp] = useState(null);
    const [showPrimaryButton, setShowPrimaryButton] = useState(false);

    const handleDappSelection = (selectedDapp) => {
        console.log("Selected dApp:", selectedDapp);
        setShowPrimaryButton(false);
        setCurrentDapp(selectedDapp);
    };

    const closeMenu = () => {
        setCurrentDapp(null);
    };

    return (
        <div className="sidebar">
            <div className="sidebar-top">
                <div className="dapp-heading">
                    <h2 style={{ color: 'black' }}>Supported dApps</h2>
                </div>
                <div className="connection-status">
                    {dAppOptions.length > 0 && (
                        <>
                            <img src={blockchainInfo.logo} alt={`${blockchainInfo.name} logo`} className="blockchain-logo" />
                            <div className="green-ball"></div>
                        </>
                    )}
                    <span>{blockchainInfo.name}</span>
                </div>
            </div>
            <div className="menu">
                <DappMenu options={dAppOptions} placeholder={placeholderText} onSelect={handleDappSelection} closeMenu={closeMenu} />
            </div>
            <div>
                {currentDapp && <DappMain 
                title={currentDapp} 
                blockchainInfo={blockchainInfo} 
                setUserMessage={setUserMessage}
                setShowWidget={setShowWidget}
                setShowPrimaryButton={setShowPrimaryButton}
                showPrimaryButton={showPrimaryButton}
                />}
            </div>
        </div> 
    );
}

export default Sidebar;
